import { render } from "./EmbedOrderDataOverview.vue?vue&type=template&id=2e262551&ts=true"
import script from "./EmbedOrderDataOverview.vue?vue&type=script&lang=ts"
export * from "./EmbedOrderDataOverview.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__